// Update src/App.js to include the workout page route

import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { User, Dumbbell, Home } from 'lucide-react';
import { Button } from './components/ui/button';
import { ThemeProvider } from 'next-themes';
import { AuthProvider } from './contexts/AuthContext';
import NutritionCalculator from './components/NutritionCalculator';
import NutritionLanding from './components/NutritionLanding';
import ProfilePage from './components/pages/ProfilePage';
import HistoryPage from './components/pages/HistoryPage';
import WorkoutPage from './components/pages/WorkoutPage';
import ResetPassword from './components/pages/ResetPassword';
import { ThemeToggle } from './components/ui/theme-toggle';
import { UserMenu } from './components/UserMenu';
import { AuthBanner } from './components/AuthBanner';
import './globals.css';
import { Toaster } from './components/ui/toaster';
import { useAuth } from './contexts/AuthContext';
import FoodLoggerPage from './components/pages/FoodLoggerPage';
import { UserPreferencesProvider } from './contexts/UserPreferencesContext';
import { EmailVerificationAlert } from './components/EmailVerificationAlert';
import { VerificationMessage } from './components/VerificationMessage';

// Header component with navigation
const Header = () => {
  const { user } = useAuth();
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const navigate = useNavigate();
  
  return (
    <header className="border-b">
      <div className="container mx-auto p-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <h1 className="text-2xl font-bold"></h1>
            {user ? (
              <Button 
                variant="ghost" 
                size="icon" 
                onClick={() => navigate('/profile')}
                title="Home"
              >
                <Home className="h-4 w-4" />
              </Button>
            ) : (
              <ThemeToggle />
            )}
          </div>
          <div>
            {user ? (
              <UserMenu />
            ) : (
              <>
                <Button variant="ghost" size="icon" onClick={() => setShowAuthDialog(true)}>
                  <User className="h-4 w-4" />
                </Button>
                <AuthBanner 
                  hideCard={true}
                  externalDialog={showAuthDialog}
                  onOpenChange={setShowAuthDialog}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

// Layout component that includes the header
const Layout = ({ children }) => {
  const { user, emailVerified } = useAuth();

  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="container mx-auto p-4">
          {/* Persistent verification message */}
          <VerificationMessage />
          
          {/* Dynamic verification alert based on current auth state */}
          {user && !emailVerified && (
            <EmailVerificationAlert email={user.email} />
          )}
          
          {children}
        </div>
      </main>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider attribute="class" defaultTheme="dark">
        <AuthProvider>
          <UserPreferencesProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<NutritionLanding />} />
                <Route path="/calculator" element={<NutritionCalculator />} />
                <Route path="/food-logger" element={<FoodLoggerPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/workouts" element={<WorkoutPage />} /> {/* Add this route */}
                <Route path="/reset-password" element={<ResetPassword />} />
              </Routes>
            </Layout>
            <Toaster />
          </UserPreferencesProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;